module.exports = __webpack_public_path__ + "static/media/maleta.5b72a437.svg";